/* global axios */
import ApiClient from './ApiClient';

class BulkEmailActionsAPI extends ApiClient {
  constructor() {
    super('conversations/bulk_email', { accountScoped: true });
  }

  /**
   * Move conversations to trash
   * @param {Object} params - { conversationIds }
   */
  batchTrash({ conversationIds }) {
    return axios.post(`${this.url}/trash`, {
      conversation_ids: conversationIds,
    });
  }

  /**
   * Archive conversations (Gmail and Microsoft only)
   * @param {Object} params - { conversationIds }
   */
  batchArchive({ conversationIds }) {
    return axios.post(`${this.url}/archive`, {
      conversation_ids: conversationIds,
    });
  }

  /**
   * Move conversations to a specific folder
   * @param {Object} params - { conversationIds, targetFolderId, targetFolderTitle, currentFolderId }
   */
  batchMove({
    conversationIds,
    targetFolderId,
    targetFolderTitle,
    currentFolderId,
  }) {
    return axios.post(`${this.url}/move`, {
      conversation_ids: conversationIds,
      target_folder_id: targetFolderId,
      target_folder_title: targetFolderTitle,
      current_folder_id: currentFolderId,
    });
  }
}

export default new BulkEmailActionsAPI();
